export class ContainersModel {
  id: number;
  tipo: string;
  tamanho: string;
}



// WEBPACK FOOTER //
// ./src/app/containers/containers.model.ts